module.exports = {"platforms":[{"message":"bottom spiked platform","type":"FiniteImmobilePlatform","x":0,"y":448,"width":800,"height":32,"display":{"assetName":"spikes"},"attributes":{"spiked":true}},{"message":"starting platform","type":"FiniteImmobilePlatform","x":64,"y":256,"width":128,"height":32,"display":{"assetName":"lanterns"}},{"message":"goal platform","type":"FiniteImmobilePlatform","x":576,"y":256,"width":128,"height":32,"display":{"assetName":"lanterns"}}],"goal":{"x":640,"y":256},"player":{"x":112,"y":256},"par":1}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-t-single-2-h.json
// module id = 133
// module chunks = 0